import EarnerCard from "./EarnerCard";
import useTranslator from "../../hooks/useTranslator";
import CloseIcon from "../../assets/img/closeIcon.svg";
import { useEffect, useState } from "react";
import { haveValue } from "../../helper/common";
import PendingGuarantorPills from "./PendingGuarantorsPill";
import { useNavigate } from "react-router-dom";
import UserPreviewCard from "./UserPreviewCard";
import PendingFlaggedGuarantors from "./PendingFlaggedGuarantors";

const GuarantorDetails = ({
  user,
  isOpen,
  onClose,
  gurantorsIncome = [],
  llShowOnly,
  isGuarantor,
  readOnly = false,
}) => {
  const { _t } = useTranslator();
  const navigate = useNavigate();
  const [pendingGuarantors, setPendingGuarantors] = useState([]);
  const [presentGuarantors, setPresentGuarantors] = useState([]);
  const [activeDropdownId, setActiveDropdownId] = useState(null);
  const [pendingDropdownId, setPendingDropdownId] = useState(null);

  useEffect(() => {
    if (haveValue(user?.gurantor_added_id)) {
      const temp_entries = user?.gurantor_added_id ?? [];

      const modifiedGuarantors = [];
      let missing = [];

      temp_entries.forEach((tempItem) => {
        const match = gurantorsIncome.find(
          (g) => g?.all_sources?._id === tempItem?.guarantor_id?._id
        );

        if (match) {
          modifiedGuarantors.push({
            ...match,
            gurantor_relation: tempItem?.gurantor_relation ?? "", // or any fields you want from tempItem
          });
        } else {
          missing.push(tempItem);
        }
      });

      if (llShowOnly) {
        missing = missing.filter(
          (item) => item.status === "present" || item.status === "processing"
        );
      }
      setPresentGuarantors(modifiedGuarantors);
      setPendingGuarantors(missing);
    }
  }, [user, gurantorsIncome]);

  const flaggedGuarantors =
    Array.isArray(user?.tenant_extra_field_id?.selected_onboarding_users) &&
    user.tenant_extra_field_id.selected_onboarding_users.filter(
      (item) => item?.type === "guarantor"
    );

  if (!isOpen) return;

  return (
    <div className="wrapper-modal" onClick={onClose}>
      <div
        className={`doc-history-popup total-salary-modal ttt ${
          isOpen ? "open" : ""
        }`}
        onClick={(e) => {
          e.stopPropagation();
          setActiveDropdownId(null);
          setPendingDropdownId(null);
        }}
      >
        <span className="drawerIcon" onClick={onClose} />
        <div>
          <div className="doc-history-header">
            <img
              src={CloseIcon}
              alt=""
              className="doc-history-close-btn"
              onClick={onClose}
            />
            <h4 className="custom-modal-heading">
              {isGuarantor ? _t("guarantees") : _t("guarantors")}
            </h4>
          </div>
          {(pendingGuarantors?.length > 0 ||
            presentGuarantors?.length > 0 ||
            user?.gurantor_for?.length > 0 ||
            flaggedGuarantors?.length > 0) && (
            <div
              className={`earner-card-wrapper pending-guarantor-wrapper cus-2 ${
                llShowOnly ? "ll-show-only" : ""
              }`}
              style={{
                height:
                  pendingGuarantors?.length === 0 &&
                  presentGuarantors?.length > 5
                    ? "78vh"
                    : presentGuarantors?.length > 5
                      ? "39vh"
                      : "auto",
              }}
            >
              {isGuarantor
                ? user?.gurantor_for.map((data) => (
                    <UserPreviewCard data={data} />
                  ))
                : presentGuarantors.map((data, index) => (
                    <>
                      <EarnerCard
                        key={index}
                        userData={data}
                        type="guarantor"
                        onClose={onClose}
                        guarantorView={true}
                        isDropdown={activeDropdownId === data?.all_sources?._id}
                        setIsDropdown={() =>
                          setActiveDropdownId(
                            activeDropdownId === data?.all_sources?._id
                              ? null
                              : data?.all_sources?._id
                          )
                        }
                        llShowOnly={llShowOnly}
                        readOnly={readOnly}
                      />
                    </>
                  ))}

              {pendingGuarantors.map((data, index) => (
                <PendingGuarantorPills
                  key={index}
                  userData={data}
                  llShowOnly={llShowOnly}
                  readOnly={readOnly}
                  isDropdown={pendingDropdownId === data?._id}
                  setIsDropdown={() =>
                    setPendingDropdownId(
                      pendingDropdownId === data?._id ? null : data?._id
                    )
                  }
                />
              ))}
              {!llShowOnly &&
                flaggedGuarantors.map((data, index) => (
                  <PendingFlaggedGuarantors
                    allUsers={
                      user.tenant_extra_field_id.selected_onboarding_users
                    }
                    key={index}
                    userData={data}
                    llShowOnly={llShowOnly}
                    readOnly={readOnly}
                    isDropdown={pendingDropdownId === index}
                    setIsDropdown={() =>
                      setPendingDropdownId(
                        pendingDropdownId === index ? null : index
                      )
                    }
                  />
                ))}
            </div>
          )}
        </div>
        {!isGuarantor && !llShowOnly && !readOnly && (
          <div className="addGuarantorButtonWrapper d-flex align-items-center justify-content-center">
            <button
              className="addGuarantorButton d-flex align-items-center justify-content-center"
              onClick={(e) => navigate("/guarantor/onboarding")}
            >
              <img src="/images/add-white.svg" alt="" />
              {_t("addGuarantor")}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default GuarantorDetails;
